import { MusicBoxMultipleOutlineIcon } from './MusicBoxMultipleOutlineIcon';

/**
 * author: Michael Irigoyen
 * id 16F694B0-E5B4-4262-91AE-DB3D0C73EEC0
 * name music-box-multiple-outline
 * version: 3.8.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/music-box-multiple-outline.svg
 * tags
 * - Music 
 */
export const LibraryMusicOutlineIcon = MusicBoxMultipleOutlineIcon;
export default LibraryMusicOutlineIcon